<template>
  <div class="deposit">
      <div class="deposit_1">

        <!-- <div :class="index_active==3?'active':'' ">
          <router-link to="/blockchain_d/deposit_fiat">{{$t('main.text747')}}</router-link>
        </div> -->
        <div :class="index_active==4?'active':'' ">
          <router-link to="/blockchain_d/deposit_jmhb">{{$t('main.text748')}}</router-link>
        </div>

      </div>
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index_active:1,
    }
  },
  methods: {
    set_active(){
      if(this.$route.path=='/blockchain_d/deposit'){
        this.index_active = 1;
      }else if(this.$route.path=='/blockchain_d/transaction_h'){
        this.index_active = 2;
      }else if(this.$route.path=='/blockchain_d/deposit_fiat'){
        this.index_active = 3;
      }else if(this.$route.path=='/blockchain_d/deposit_jmhb'){
        this.index_active = 4;
      }

    },
  },
  mounted() {
    this.set_active();
  },
  watch:{
    $route(){
      this.set_active();
    }
  }
}
</script>

<style scoped>
/* 滚动条 */
/* .deposit {
  overflow: auto;
  height: calc(100vh - 80px);
}
.deposit::-webkit-scrollbar {
  width: 5px;
}
.deposit::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #687eec;
} */
/* --over-- */

.deposit_1{
  border-bottom: 1px solid #314B69;
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
}
.deposit_1 a{
  color: #fff;
}
.deposit_1>div{
  margin-right: 40px;
}
.active{
  font-style: normal;
  font-weight: 700;
  color: #00C18E;
  border-bottom: 3px solid #00C18E;
  padding-bottom: 4px;
}
.active a{
  color: #00C18E;
}
</style>